import React from 'react';
import { RootState } from '../redux/store';
import { CalendarCheck } from 'lucide-react';
import { Button } from './Button';
import { resetAppointment } from '../redux/slices/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatSelectedSlot, titlise } from '../utils/helpers';

interface SuccessCardProps {
  className?: string;
  isSmartBooking?: boolean;
  success: {time: string; patientName: string }
}

export const SuccessCard = ({ className = '', isSmartBooking, success }: SuccessCardProps) => {
const dispatch = useDispatch();
const navigate = useNavigate();
const location = useLocation();

  return (
    <div className={`space-y-5 py-2 flex justify-center flex-col items-center${className}`}>
        <CalendarCheck size={60}  className="text-success-700"/>
        <div className="text-xl font-normal text-black text-center">
          {success.patientName}, we've got you<br/>confirmed for your appointment
        </div>
        <div className="text-xl font-bold text-black text-center">{formatSelectedSlot(success.time || '')}</div>
        <div className="flex justify-between">
          <Button
            title='Book another appointment'
            variant='primary'
            onClick={() => {
              dispatch(resetAppointment());
               if (isSmartBooking) {
                navigate(`/bookonline/smart-booking${location.search || ''}`);
              } else {
                navigate('/bookonline/step-1');
              }
            }}
          />
        </div>
    </div>
  
              
  );
};